export function createClipWorker(): Worker {
  return new Worker(new URL('./clip-worker.ts', import.meta.url), {
    type: 'module',
  })
}
